import { createContext, useContext, useState, useEffect } from "react";
import { authAPI } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const usuarioGuardado = localStorage.getItem("usuario");
    if (token && usuarioGuardado) {
      setUsuario(JSON.parse(usuarioGuardado));
      authAPI.me()
        .then((res) => setUsuario(res.data.data))
        .catch(() => cerrarSesion())
        .finally(() => setCargando(false));
    } else {
      setCargando(false);
    }
  }, []);

  const iniciarSesion = (token, datosUsuario) => {
    localStorage.setItem("accessToken", token);
    localStorage.setItem("usuario", JSON.stringify(datosUsuario));
    setUsuario(datosUsuario);
  };

  const cerrarSesion = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("usuario");
    setUsuario(null);
  };

  const esSuperAdmin = usuario?.role === "super_admin";

  return (
    <AuthContext.Provider value={{ usuario, cargando, iniciarSesion, cerrarSesion, esSuperAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
